(function () {
  var V = window.VNYC || {};
  var ROOT = (V.root || '/').replace(/\/$/, '');
  function group(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents) {
    var f = V.moneyFormat || '${{amount}}';
    var p = (cents / 100).toFixed(2).split('.');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return group(String(Math.round(cents / 100)), ',');
      if (k === 'amount_with_comma_separator') return group(p[0], '.') + ',' + p[1];
      return p[1] === '00' ? group(p[0], ',') : group(p[0], ',') + '.' + p[1];
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/'/g, '&#39;').replace(/\x22/g, '&quot;'); }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function setCount(n) { document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = n; }); }

  /* bag drawer */
  var lastFocus = null;
  function openCart() {
    var d = document.getElementById('v-drawer'); if (!d) return;
    lastFocus = document.activeElement;
    document.body.classList.add('v-cart-open'); d.setAttribute('aria-hidden', 'false');
    var c = d.querySelector('[data-cart-close]'); if (c) c.focus();
  }
  function closeCart() {
    var d = document.getElementById('v-drawer'); if (!d) return;
    document.body.classList.remove('v-cart-open'); d.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function lineHtml(it) {
    var props = '';
    if (it.properties) Object.keys(it.properties).forEach(function (k) { var v = it.properties[k]; if (k.charAt(0) !== '_' && v) props += '<span>' + esc(v) + '</span>'; });
    var variant = it.variant_title && !it.product_has_only_default_variant ? '<span>' + esc(it.variant_title) + '</span>' : '';
    return '<li class="v-line"><a class="v-media" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 240)) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="v-lt"><b>' + esc(it.product_title) + '</b>' + variant + '<span>' + money(it.final_line_price) + '</span>' + props +
      '<div class="v-qty"><button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="v-rm" data-q="' + esc(it.key) + '" data-n="0">Remove</button></div></li>';
  }
  function render(cart) {
    setCount(cart.item_count);
    var list = document.querySelector('[data-cart-items]'), foot = document.querySelector('[data-cart-foot]');
    if (!list) return;
    if (!cart.item_count) { list.innerHTML = '<li class="v-cart-empty">Your bag is empty.</li>'; foot.hidden = true; return; }
    list.innerHTML = cart.items.map(lineHtml).join('');
    var st = document.querySelector('[data-cart-subtotal]'); if (st) st.textContent = money(cart.total_price);
    foot.hidden = false;
  }
  function getJSON(r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }
  function fetchCart() { return fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } }).then(getJSON); }
  function change(key, qty) {
    return fetch(ROOT + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) }).then(getJSON).then(render);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t && document.getElementById('v-drawer')) { e.preventDefault(); closeMenu(); fetchCart().then(render); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var q = e.target.closest('[data-q]');
    if (q) { change(q.getAttribute('data-q'), parseInt(q.getAttribute('data-n'), 10)); return; }
    var m = e.target.closest('[data-menu]');
    if (m) { m.getAttribute('data-menu') === 'open' ? openMenu() : closeMenu(); }
  });
  function openMenu() { var n = document.getElementById('v-mnav'); if (!n) return; n.classList.add('is-open'); n.setAttribute('aria-hidden', 'false'); document.querySelectorAll('[data-menu=open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); }
  function closeMenu() { var n = document.getElementById('v-mnav'); if (!n) return; n.classList.remove('is-open'); n.setAttribute('aria-hidden', 'true'); document.querySelectorAll('[data-menu=open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

  /* product page */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var form = root.querySelector('form[data-product-form]');
    if (!form) return;
    var idIn = form.querySelector('input[name=id]');
    var btn = form.querySelector('[data-atb]');
    var priceEl = root.querySelector('[data-price]');
    var msg = root.querySelector('[data-msg]');
    var single = variants.length === 1;
    var busy = false;

    function chosen() {
      var sets = root.querySelectorAll('[data-opt]'), vals = [];
      for (var i = 0; i < sets.length; i++) { var c = sets[i].querySelector('input:checked'); if (!c) return null; vals.push(c.value); }
      return vals;
    }
    function match(vals) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0]; }
    function update(scrollToMedia) {
      var vals = single ? null : chosen();
      var v = single ? variants[0] : (vals && match(vals));
      if (busy) return;
      if (!v) { idIn.value = ''; btn.disabled = true; btn.textContent = btn.getAttribute('data-select'); return; }
      idIn.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      btn.disabled = !v.available;
      btn.textContent = btn.getAttribute(v.available ? 'data-add' : 'data-soldout');
      if (!single && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      if (scrollToMedia && v.featured_media) { var s = root.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if (s) s.parentElement.scrollTo({ left: s.offsetLeft - s.parentElement.offsetLeft, behavior: 'smooth' }); }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) { if (msg) msg.textContent = ''; update(true); } });
    update(false);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idIn.value) { if (msg) msg.textContent = btn.getAttribute('data-select'); return; }
      busy = true; btn.disabled = true;
      fetch(ROOT + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(getJSON)
        .then(fetchCart)
        .then(function (cart) { render(cart); openCart(); })
        .catch(function (err) { if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add to bag. Please try again.'; })
        .then(function () { busy = false; update(false); });
    });

    var track = root.querySelector('[data-track]'), count = root.querySelector('[data-count]');
    if (track && track.children.length > 1) {
      var n = track.children.length;
      var idx = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      track.addEventListener('scroll', function () { if (count) count.textContent = (idx() + 1) + ' / ' + n; }, { passive: true });
      root.querySelectorAll('[data-go]').forEach(function (b) {
        b.addEventListener('click', function () { var i = (idx() + parseInt(b.getAttribute('data-go'), 10) + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
      });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var i = (idx() + (e.key === 'ArrowRight' ? 1 : -1) + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); } });
    }
    var sg = root.querySelector('[data-size-guide]');
    if (sg) sg.addEventListener('click', function () { var d = root.querySelector('[data-fit]'); if (d) { d.open = true; d.scrollIntoView({ block: 'center', behavior: 'smooth' }); } });
  });
})();
